<template>
  <modal
    :show.sync="isActiveLeave"
    size="lg"
    centered
    header-classes="bg-primary items-center rounded-none text-lg uppercase font-bold"
    modal-content-classes="cust-modal-ht-wo cust-overflow-y-grey"
    hide-footer
    class="overflow-y-hidden custcenter"
    @close="closeModal"
  >
    <div class="flex justify-end">
      <img
        src="@/assets/images/cross.png"
        class="h-8 w-8 cursor-pointer"
        alt="cross"
        @click="isActiveLeave = false"
      />
    </div>
    <h2 class="fsize25 sm-fsize18 text-center">Show us your love</h2>
    <p class="fsize20 sm-fsize16 text-center">
      Your Testimonial is like a virtual hug for us that will energize us
    </p>

    <div class="mt-4">
      <FileUploader
        v-show="!image"
        :image="image"
        :onSuccess="handleSuccess"
        class="rounded-full widtht20percent m-auto display-none custmodal"
      />
      <img
        v-if="image"
        :src="image"
        ref="cover"
        class="rounded-full widtht20percent m-auto display-none custmodal"
      />
      <div
        class="flex justify-center text-red"
        v-if="image"
        @click="handleRemove"
      >
        Remove image
      </div>
      <span v-if="imageErr" class="flex justify-center small text-danger">{{
        msg.image
      }}</span>
      <p class="text-center">Upload your picture (optional)</p>
    </div>
    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <div class="py-4 customboxed">
          <p class="mb-1">
            We would like to know you<span class="text-red"> *</span>
          </p>
          <base-input
            class=""
            name="Link"
            placeholder="Enter your name"
            v-model="name"
            @blur="handleName()"
          >
          </base-input>
          <span v-if="nameErr" class="small text-danger">{{ msg.name }}</span>
        </div>
        <div class="customboxed">
          <p class="mb-1">Profession<span class="text-red"> *</span></p>
          <base-input
            class="mb-3"
            name="Link"
            placeholder="Enter your profession"
            v-model="profession"
          >
          </base-input>
        </div>
        <!-- <div class="mb-4 mt-3">
          <p class="mb-1">
            How do you relate with Caregiver Saathi<span class="text-red">
              *</span
            >
          </p>
          <b-form-select class="w-full custinputborder py-2" v-model="relate">
            <option selected value="">Open this select menu</option>
            <option value="Well-wisher">Well-wisher</option>
            <option value="Caregiver">Caregiver</option>
            <option value="Healthcare professional">
              Healthcare professional
            </option>
          </b-form-select>
        </div> -->
        <div class="customboxed mb-3">
          <p class="mb-1">
            Tell us what else we could do, that will be meaningful for
            caregivers
          </p>
          <base-input
            class="mb-3"
            name="Link"
            placeholder="Type"
            v-model="suggestion"
          >
          </base-input>
        </div>
        <div class="customboxed">
          <p class="mb-1">Your Testimonial<span class="text-red"> *</span></p>
          <b-form-textarea
            class="mb-3 w-full py-2"
            name="Link"
            placeholder="Type"
            v-model="description"
          >
          </b-form-textarea>
        </div>
        <div class="flex">
          <b-checkbox v-model="isHidden" />
          <p>Do you want to keep your name hidden</p>
        </div>
        <base-button
          type="primary"
          class="w-full my-2 fsize18"
          native-type="submit"
          >Submit</base-button
        >
      </b-form>
    </validation-observer>
    <!-- <div v-html="selectedTesimonial.html"></div> -->
    <template slot="footer"> <div></div> </template>
  </modal>
</template>

<script>
import FileUploader from "@/components/FileUploader";
// import { mapState } from "vuex";

export default {
  data() {
    return {
      name: "",
      description: "",
      isHidden: false,
      profession: "",
      relate: "",
      suggestion: "",
      image: null,
      coverImage: null,
      nameErr: false,
      imageErr: false,
      msg: {
        image: "",
        name: "",
      },
    };
  },
  components: {
    FileUploader,
  },
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    selectedTesimonial: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    isActiveLeave: {
      get() {
        return this.isActive;
      },
      set(val) {
        if (!val) {
          this.closeModal();
        }
      },
    },

    // ...mapState("testimonial", {
    //   testimonial: "testimonial",
    // }),
  },

  methods: {
    handleName() {
      this.nameErr = false;
      if (!/^[a-zA-Z]+$/.test(this.name)) {
        this.nameErr = true;
        this.msg.name = "Name should not be numeric value";
      }
    },
    handleSuccess(image) {
      let mByte = 5 * 1048576;
      if (image.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          // text: "Please ensure that the file size does not exceed 5MB",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }
      this.imageErr = false;
      if (!image.type.includes("image")) {
        this.imageErr = true;
        this.msg.image = "Upload Image Only";
      } else {
        this.imageErr = false;

        this.coverImage = image;
        this.readerData(image);
      }
    },

    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    // async getAllTestimonial() {
    //   let loader;
    //   try {
    //     let payload = {
    //       limit: 50,
    //       status: "Accept",
    //     };
    //     loader = this.$loading();
    //     const allTestimonial = await this.$store.dispatch(
    //       "testimonial/getAllTestimonial",
    //       payload
    //     );
    //     loader.close();
    //     // console.log(allTestimonial);
    //   } catch (error) {
    //     console.log(error);
    //     loader.close();
    //   }
    // },
    async onSubmit() {
      this.name = this.name.trim();
      this.description = this.description.trim();
      this.profession = this.profession.trim();
      // this.relate = this.relate.trim();
      this.suggestion = this.suggestion.trim();

      if (
        this.name === "" ||
        this.description === "" ||
        this.profession === ""
        // this.relate === ""
      ) {
        await this.$swal({
          // text: "please add title, description, date and Time",
          text: `Please enter all the required details!`,
          icon: "warning",
          showCancelButton: false,
          confirmButtonColor: "#830c81",
        });
        return;
      }

      const payload = new FormData();
      payload.append("name", this.name);
      payload.append("description", this.description);
      payload.append("profession", this.profession);
      payload.append("isHidden", this.isHidden);
      // payload.append("relate", this.relate);
      payload.append("status", "Accept");
      payload.append("isAdmin", true);

      if (this.coverImage) payload.append("testimonialImage", this.coverImage);

      if (this.suggestion !== "") payload.append("suggestion", this.suggestion);
      let loader;
      try {
        // console.log(payload);
        loader = this.$loading();
        const createTestimonial = await this.$store.dispatch(
          "ffc/add_testimonial",
          payload
        );

        if (createTestimonial.code === 200) {
          // console.log(createTestimonial);
          loader.close();
          this.closeModal();
          await this.$swal({
            text: "Your Testimonial has been successfully created!",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });

          this.name = "";
          this.description = "";
          this.profession = "";
          this.isHidden = false;
          // this.relate = "";
          this.suggestion = "";
          this.coverImage = null;
          this.image = null;
          // this.getAllTestimonial();
          // console.log(this.testimonial);
        }
        loader.close();
      } catch (error) {
        loader.close();
        console.log(error);
      }
    },
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>
<style>
.custinputborder {
  border: 1px solid #808080;
  border-radius: 4px;
}
.widtht20percent {
  width: 24%;
  height: 140px !important;
}
.modal-lg {
  width: 650px;
}
@media (max-width: 640px) {
  .modal-lg {
    width: 330px;
  }
  .widtht20percent {
    width: 50%;
    height: 140px !important;
  }
}
.show {
  padding-left: 0px !important;
}
</style>
